var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.classes,
      attrs: {
        role: "radio",
        tabindex: "0",
        "aria-label": _vm.option.title,
        "aria-checked": _vm.ariaChecked,
      },
      on: {
        click: _vm.onClick,
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.onClick.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.onClick.apply(null, arguments)
          },
        ],
      },
    },
    [
      _c("div", {
        staticClass: "trbo-a-gallery-item__image",
        style: _vm.imageStyles,
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "trbo-a-gallery-item__content" },
        [
          _c("div", { staticClass: "trbo-a-gallery-item__title-actions" }, [
            _c("div", { staticClass: "trbo-a-gallery-item__title" }, [
              _c(
                "div",
                { staticClass: "trbo-a-gallery-item__title__content" },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.option.title) + "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "trbo-a-gallery-item__actions" }, [
              _vm.hasInfoText
                ? _c(
                    "div",
                    {
                      staticClass: "trbo-a-gallery-item__info-icon",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c("info-icon", {
                        attrs: {
                          role: "tooltip",
                          tabindex: "0",
                          "main-icon": _vm.infoIcon,
                          "is-opened": _vm.isOpened,
                          "aria-labelledby": _vm.infoId,
                        },
                        on: {
                          click: _vm.onToggleIsOpened,
                          "esc-pressed": _vm.closeToggle,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.option.description
            ? _c(
                "animation-height",
                { attrs: { "is-visible": !_vm.isOpened, "use-opacity": "" } },
                [
                  _c(
                    "div",
                    { staticClass: "trbo-a-gallery-item__description" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.option.description) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasInfoText
            ? _c(
                "animation-height",
                { attrs: { "is-visible": _vm.isOpened, "use-opacity": "" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "trbo-a-gallery-item__info-text",
                      attrs: { id: _vm.infoId, "aria-hidden": !_vm.isOpened },
                    },
                    [
                      _c("info-text", {
                        attrs: {
                          "is-opened": _vm.isOpened,
                          title: _vm.infoTitle,
                          description: _vm.infoDescription,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }